export default __webpack_public_path__ + "svg/calendar/2026/8/noviembre.svg?120a6dc1";